import {
  betStatus,
  clearBetStatusResponse,
  clearExchangeBets,
  fetchBalance,
  fetchMultiMarketEventData,
  fetchOpenBets,
  getBookmakerMarketsByEvent,
  getSecondaryMarketsByEvent,
  getSecondaryMatchOddsByEvent,
  setBettingInprogress,
  showToast,
  useAppDispatch,
  useAppSelector,
  BET_TIMEOUT,
  getHouseIdFromToken,
  getParentIdFromToken,
  IMultiMarket,
  getAllMarketsByEvent,
} from "@hypexone/uicore";
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useMarketLocalState } from "../../../utils/hooks/storage.hooks";
import MultiMarkets from "./MultiMarkets";
import { pnService } from "../../../webSocket/SocketServices";
import { commonClient, errorHandler } from "../../../App.utils";
import CommonClient from "@hypexone/uicore/lib/cjs/src/client/reddog/common_client";
import { getBaseUrl, getEnvUrlsMap } from "../../../api/api-services/environment-url/environment-url";
import useWindowDimensions from "@hypexone/uicore/lib/cjs/src/utils/hooks/useWindowDimensions.hooks";

const MultiMarketView = () => {
  const dispatch = useAppDispatch();
  const {
    secondaryMultiMarketsMap: secondaryMultiMarket,
    secondaryMultiMatchOddsMap: secondaryMultiMatchOdds,
    multiMarketData: marketData,
    triggerFetchMarkets,
    triggerFetchOrders,
    triggerBetStatus,
  } = useAppSelector((state) => state.multiMarket);
  const { bets, betStatusResponse, openBets } = useAppSelector(
    (state) => state.betSlip
  );
  const { loggedIn } = useAppSelector((state) => state.auth);
  const {
    pushNotifWSConnection,
    topicUrls,
    events,
    selectedEventType,
    selectedCompetition,
  } = useAppSelector((state) => state.catalog);
  const { langData } = useAppSelector((state) => state.cms);

  const { screenWidth } = useWindowDimensions();
  const isMdBreakpoint = screenWidth >= 768;
  const isXLBreakpoint = screenWidth >= 1280;

  const [tabPanel, setTabPanel] = useState<"odds" | "myBets">("odds");
  const [exposureMap, setExposureMap] = useState(new Map());
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);
  const [startTime, setStartTime] = useState<Date>();
  const [fetchOpenOrders, setFetchOpenOrders] = useState<number>(null);
  const [addNewBet, setAddNewBet] = useState<boolean>(true);
  const intervalRef = useRef(null);
  const isFirstRender = useRef(true);
  const isFirstRenderStartTime = useRef(true);
  
  // const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [multiMarketData] = useMarketLocalState();

  const houseId = getHouseIdFromToken();
  const parentId = getParentIdFromToken();
  const accountId = sessionStorage.getItem("aid");
  const SVLS_BASE_URL = getBaseUrl(
    import.meta.env.VITE_NODE_ENV,
    "REACT_APP_REST_API_V2_URL"
  );
  const commonClient = new CommonClient(
    SVLS_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const fetchOpenBetsRisk = useCallback(
    async (multiMarketData: IMultiMarket[]) => {
      try {
        if (!multiMarketData?.length) {
          return;
        }

        const eventIds = [];
        const marketIds = [];
        multiMarketData.forEach((item) => {
          eventIds.push(item?.eventId);
          marketIds.push(item?.marketId);
        });

        const response = await commonClient.getUserRisk(
          Array.isArray(eventIds) ? eventIds.join(",") : eventIds,
          Array.isArray(marketIds) ? marketIds.join(",") : marketIds
        );
        setExposureMap(response.data.marketExposureMap);
      } catch (e) {
        console.log(e);
      }
    },
    []
  );

  useEffect(() => {
    dispatch(fetchMultiMarketEventData());
  }, [triggerFetchMarkets]);

  useEffect(() => {
    if (multiMarketData?.length) {
      const eventIds = [];

      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      dispatch(fetchOpenBets({ eventId: eventIds }));
      fetchOpenBetsRisk(multiMarketData);
    }
    setEnableFetchOrders(true);
  }, [multiMarketData]);

  useEffect(() => {
    if (loggedIn && enableFetchOrders && multiMarketData?.length) {
      const eventIds = [];

      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      setTimeout(() => {
        dispatch(fetchOpenBets({ eventId: eventIds }));
        fetchOpenBetsRisk(multiMarketData);
      }, 1000);
    }
  }, [loggedIn, triggerFetchOrders, fetchOpenOrders]);

  useEffect(() => {
    if (loggedIn) {
      pnService.subscribeWsForNotificationsPerAdmin(
        true,
        houseId,
        parentId,
        accountId
      );
      pnService.subscribeWsForNotifications(true, houseId);
    }
  }, [pushNotifWSConnection, loggedIn]);

  useEffect(() => {
    if (betStatusResponse === null) {
      return;
    }

    switch (betStatusResponse.status) {
      case "IN_PROGRESS": {
        dispatch(
          showToast({
            type: "error",
            message: betStatusResponse.message,
          })
        );

        break;
      }
      case "SUCCESS": {
        dispatch(
          showToast({
            type: "success",
            message: betStatusResponse.message,
          })
        );
        if (addNewBet) {
          setFetchOpenOrders(moment.now());
        }
        dispatch(fetchBalance());
        break;
      }
      case "FAIL": {
        dispatch(
          showToast({
            type: "error",
            message: "Bet failed - " + betStatusResponse.message,
          })
        );
        break;
      }
    }

    dispatch(setBettingInprogress(false));
    if (bets[0]?.amount) {
      dispatch(clearExchangeBets());
    }
    dispatch(clearBetStatusResponse());
  }, [betStatusResponse]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    clearInterval(intervalRef.current);
    dispatch(betStatus());
  }, [triggerBetStatus]);

  useEffect(() => {
    if (isFirstRenderStartTime.current) {
      isFirstRenderStartTime.current = false;
      return;
    }

    intervalRef.current = setInterval(() => {
      dispatch(betStatus());
      clearInterval(intervalRef.current);
    }, BET_TIMEOUT);

    return () => clearInterval(intervalRef.current);
  }, [startTime]);

  useEffect(() => {
    dispatch(setBettingInprogress(false));
    if (bets[0]?.amount) {
      dispatch(clearExchangeBets());
    }
    dispatch(clearBetStatusResponse());
  }, []);

  const renderEventData = useMemo(() => {
    return getAllMarketsByEvent(
      events,
      selectedEventType?.id,
      selectedCompetition?.id,
      bets[0]?.eventId
    );
  }, [
    events,
    selectedEventType?.id,
    selectedCompetition?.id,
    bets[0]?.eventId,
  ]);

  return (
    <div className="pb-10">
      <div className="flex justify-between items-center gap-3 text-white bg-black1 px-2 py-1.5 md:py-1">
        Multi Market
      </div>
      {
        multiMarketData?.length && marketData && Object.keys(marketData)?.length
          ? Object.keys(marketData).map((item) => {
            return (
              <MultiMarkets
                key={item}
                topicUrls={topicUrls}
                loggedIn={loggedIn}
                eventData={marketData[item]}
                secondaryMarkets={getSecondaryMarketsByEvent(
                  secondaryMultiMarket,
                  item
                )}
                secondaryMatchOdds={getSecondaryMatchOddsByEvent(
                  secondaryMultiMatchOdds,
                  item
                )}
                bmMData={getBookmakerMarketsByEvent(
                  secondaryMultiMarket,
                  item
                )}
                // eventId={marketData[item]?.eventId}
                isMultiMarket={true}
                exposureMap={exposureMap ? exposureMap : null}
                setBetStartTime={(date) => setStartTime(date)}
                setAddNewBet={(val) => setAddNewBet(val)}
              />
            );
          })
          : null
        // : < MultiMarketDesktop />
      }
      {(multiMarketData?.length === 0 ||
        Object.keys(marketData)?.length === 0) && (
          <div className="no-data multimarket-no-data bg-white border-gray-600 rounded-md p-4 m-2 text-gray-500 font-bold text-center">
            There are currently no followed multi markets.
            <div className="h-[1px] w-full bg-gray-200 my-2"></div>
            <div className="text-center font-medium text-gray-400">
              Please add some markets from events
            </div>
          </div>
        )}
    </div>
  );
};

export default MultiMarketView;
